<template>
  <transition name="slider-transition">
    <Slider
      v-if="$slots.default"
      :length="length"
      :has-ads="lengthAds > 0"
      :length-ads="lengthAds"
    >
      <slot></slot>
    </Slider>
    <ContentLoading v-else-if="loading"></ContentLoading>
    <ContentError
      :error="error"
      v-else-if="error && error.message"
    ></ContentError>
  </transition>
</template>

<script>
import Slider from "./Slider";
import ContentLoading from "./ContentLoading";
import ContentError from "./ContentError";

export default {
  name: "Content",
  components: {
    Slider,
    ContentError,
    ContentLoading
  },
  props: {
    error: Object,
    loading: Boolean,
    length: Number,
    lengthAds: {
      type: Number,
      required: false,
      default: 0
    }
  }
};
</script>

<style lang="scss" scoped>
.slider {
  //Transition
  max-height: 550px;
  opacity: 1;

  &-transition-enter-active {
    transition: max-height 0.45s, opacity 0.35s;
  }

  &-transition-enter,
  &-transition-leave-to {
    max-height: 0;
    opacity: 0;
  }
}
</style>
